module.exports = __webpack_public_path__ + "img/daily.e8936aa5.svg";